import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Detailcard from './Details';
import { Container, Row, Col, Card } from 'react-bootstrap';
import logo from '../../Assets/logo2.jpg';
import pic from '../../Assets/abc.png';
import Pagination from 'react-bootstrap/Pagination';
import { ApiCall } from '../../apicall';
import './queryStyle.css';
import { Microphone, Question } from 'phosphor-react';
import { useNavigate } from 'react-router-dom';
import fieldsLang from './fieldsLang.json';
import JasonFile from './langVoiceCodes.json';
import axios from 'axios';
import { v4 as uuidV4 } from 'uuid';
import Spinner from 'react-bootstrap/Spinner';

function QueryPage() {
  const [category, serCategory] = useState('schemes');
  const [queryUpdate, SetQueryUpdate] = useState([]);
  const [relatedQuery, setRelatedQuery] = useState([]);
  const [cuurentQuery, setCurrentQuery] = useState('');
  const [currentLang, setCurrentLang] = useState('en-IN');
  const [translatedQuery, setTranslatedQuery] = useState([]);
  const [translatedAnwers, setTranslatedAnwers] = useState([]);
  const [getselectedScheme, setSelectedScheme] = useState();
  const [isSchemeSelected, setIsSchemeSelected] = useState(false);
  const [suggestionLoader,setSuggestionLoader] = React.useState(false);
  const navigate = useNavigate();
  const getQueryResp = async category => {
    let config = {
      'Content-Type': 'application/json',
    };

    const output = await ApiCall(
      'get',
      'fetch-sample-prompts/' + category,
      config,
    );
    localStorage.setItem('datanow', output.data);
    // setText(output.data.answer);
    SetQueryUpdate(output.data);
    let value = localStorage.getItem('selectedLang');
    // translate
    const answer = Object.values(output.data);
    // const fullArray = question.concat(answer);
    const fullArray = answer;
    const res = [];
    const res2 = [];
    fullArray.map(it => {
      let query = { text: it.query };
      let anwers = { text: it.answer };
      res.push(query);
      res2.push(anwers);
    });
     //query
     TranslationAPIMethod(value, res, setTranslatedQuery);
     //anwers
     TranslationAPIMethod(value, res2, setTranslatedAnwers);
    // translate
  };
  useEffect(() => {
    getQueryResp(category);
    let langvalue = localStorage.getItem('selectedLang');
    setCurrentLang(langvalue);
  }, []);

  const TranslationAPIMethod =async(value, res,setField) => {
    const post = {outputLang:value,
    text:res}
    //query translation
    // axios
    //   .post(
    //     `https://api.cognitive.microsofttranslator.com/translate?api-version=3.0&to=${value}`,
    //     res,
    //     {
    //       headers: {
    //         'Ocp-Apim-Subscription-Key': '7f2623d635f944d7969e462d54f8c5cc',
    //         'Ocp-Apim-Subscription-Region': 'centralindia',
    //         'Content-type': 'application/json',
    //         'X-ClientTraceId': uuidV4().toString(),
    //       },
    //     },
    //   )
    await ApiCall('post','text-to-text','',post)
      .then(resp => {
        let ram = resp.data;
        let TranslateQueryArray = [];
        ram.map(it => {
          const { text } = it.translations[0];
          TranslateQueryArray.push(text);
        });

        setField(TranslateQueryArray);
      })
      .catch(err => {
        console.log(err);
      });
    ////query translation
  };

  // =========Pagination logic=========
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setPostPerPage] = useState(9);
  const lastPostIndex = currentPage * postPerPage;
  const firstPostIndex = lastPostIndex - postPerPage;
  const c_post = queryUpdate.slice(firstPostIndex, lastPostIndex);
  const total_page = Math.ceil(queryUpdate.length / postPerPage);
  const page_arr = [...Array(total_page).keys()];
  // =========Pagination logic=========
  const handleLanguage = async value => {
    localStorage.setItem('selectedLang', value);
    setCurrentLang(value);
    setIsSchemeSelected(false);
    localStorage.setItem('selectedVoice', JasonFile[1][value]);
    const question = Object.keys(queryUpdate);
    const answer = Object.values(queryUpdate);
    // const fullArray = question.concat(answer);
    const fullArray = answer;
    const res = [];
    const res2 = [];
    fullArray.map(it => {
      let query = { text: it.query };
      let anwers = { text: it.answer };
      res.push(query);
      res2.push(anwers);
    });
    //query
    TranslationAPIMethod(value, res, setTranslatedQuery);
    //anwers
    TranslationAPIMethod(value, res2, setTranslatedAnwers);

  };

  useEffect(() => {
    const people = translatedQuery.map((name, index) => {
      return Object.assign(
        {},
        {
          query: name,
          answer: translatedAnwers[index],
          category: 'agriculture',
        },
      );
    });
    SetQueryUpdate(people);
  }, [translatedAnwers]);

  const handleSchemeFilter = data => {
    setIsSchemeSelected(true);
    setSuggestionLoader(true);
    let temp = queryUpdate.filter(it => {
      if (data == it.query) {
        return it;
      }
    });
    setSelectedScheme(temp);
    getQuerieRelatedMethod(data);
  };
// -------related queries --------------------------------
      const getQuerieRelatedMethod = async(queryUpdate)=>{  
         setSuggestionLoader(true)
        const selectedLang = localStorage.getItem('selectedLang');
        const data = {
          text:queryUpdate,
          langSelected:selectedLang
        }
        await ApiCall('post','fetch-related-query-api',{},data)
        .then(res=>{
           setSuggestionLoader(false)
          setRelatedQuery(res.data.answer);
        })
        .catch(err=>{
           setSuggestionLoader(false)
        })
      }

      //ask questions
      const sendQueryAsInput = async (data) => {
        localStorage.setItem('SelectedQueryAsInput', data);
        navigate('/govtofindiascheme/Selected-query');
      };
    

  return (
    <>
      <Container>
        <Row className='justify-content-center'>
          <div className="cardtitle displaytwo mt-5 d-flex justify-content-between align-items-center">
            <div className="select-dropdown" style={{ marginRight: 10 }}>
              <select  value={currentLang}
                onChange={e => {
                  handleLanguage(e.target.value);
                }}>
                {Object.entries(JasonFile[0]).map((res, i) => {
                  return (
                    <option key={i} value={res[0]}>
                      {res[1]}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="rightDiv d-flex justify-content-start align-items-center">
              {/* <p className='mb-0'>{fieldsLang[0][currentLang]} : </p>  */}
              {/* <Link className='askBtn'><Question size={20} /> Ask Your Own Question</Link>git */}
              {/* <input  value={category} onChange={e => serCategory(e.target.value)} style={{ marginLeft:10,}}/> */}{' '}
              <div
                className="select-dropdown"
                style={{ marginLeft: 10, marginRight: 10 }}>
                <select
                  onChange={e => {
                    handleSchemeFilter(e.target.value);
                  }}>
                  <option value={''}>{fieldsLang[14][currentLang]}</option>
                  {queryUpdate && queryUpdate.length > 0 ? (
                    queryUpdate.map((it, key) => (
                      <option key={key} value={it.query}>
                        {it.query}
                      </option>
                    ))
                  ) : (
                    <></>
                  )}
                </select>
              </div>
              {/* <button onClick={() => getQueryResp(category)} style={{marginRight:10, marginLeft:10,}}>{fieldsLang[9][currentLang]}</button> */}
         
            </div>
            <div className='d-flex justify-content-end align-items-center'>
            <button
                onClick={() => {
                  navigate('/govtofindiascheme/Voiceinput ');
                }}
                style={{
                  width: 'max-content',
                  paddingLeft: 15,
                  paddingRight: 15,
                }}>
               
                {fieldsLang[10][currentLang]} {' '}
                <Microphone size={24} weight="fill"/>
              </button>
            </div>
          </div>

          {!isSchemeSelected && queryUpdate && queryUpdate.length > 0 ? (
            c_post.map((it, key) => (
              <Col lg={4} className="card-div" key={key}>
                <Detailcard
                  imagesrc={
                    category === 'Education'
                      ? logo
                      : category === 'Financial'
                      ? pic
                      : category === 'Architecture'
                      ? pic
                      : logo
                  }
                  disc={it.answer}
                  title={it.query}
                  currentLang={currentLang}
                />
              </Col>
            ))
          ) : (
            <></>
          )}
          {/* selected drop down */}
          {isSchemeSelected &&
          getselectedScheme &&
          getselectedScheme.length > 0 ? (
            getselectedScheme.map((it, key) => (
              <Col lg={8} className="card-div" key={key}>
                <Detailcard
                  imagesrc={
                    category === 'Education'
                      ? logo
                      : category === 'Financial'
                      ? pic
                      : category === 'Architecture'
                      ? pic
                      : logo
                  }
                  disc={it.answer}
                  title={it.query}
                  currentLang={currentLang}
                />
              </Col>
            ))
          ) : (
            <></>
          )}
          {!isSchemeSelected ? (
            <div className="d-flex justify-content-center">
              <Pagination>
                {page_arr.map((i, x) => (
                  <Pagination.Item
                    key={i}
                    onClick={() => {
                      setCurrentPage(i + 1);
                    }}
                    active={i + 1 === currentPage}>
                    {i + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </div>
          ) : (
            <div></div>
          )}
        </Row>
      </Container>
      {isSchemeSelected ? (  
      <section className='cardsarea'>
        <Container>  
          <div className='bordertop'>   
          <Row>
          {suggestionLoader?<>       <div className="newload">    <Spinner animation="border" role="status" variant="dark" >
      <span className="visually-hidden">Loading...</span>
    </Spinner></div>
    </>:<>
          {relatedQuery?<h3><b>{fieldsLang[15][currentLang]}</b></h3> :<></>}
          {relatedQuery && relatedQuery.length>0?relatedQuery.map((it,key)=>(
            <Col md={3} lg={3} xxl={3} key={key}>            
            {it.length>0?
            <Card className="cardTwo" onClick={()=>{sendQueryAsInput(it.slice(2,it.length))}}>
              <Card.Body>
                <Card.Title>{it}?</Card.Title>
              </Card.Body>
            </Card>:<></>}
            </Col>
          )):<></>}</>}
          </Row>
          </div>  
        </Container>
      </section>
      ) : (
        <div></div>
      )}
    </>
  );
}

export default QueryPage;
